import vademecumService from "../../../services/vademecum/Vademecum.js";
import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            total: 0,
            loading: false,
            vademecumDataEdit: [],
            showEditVadmecum: false,
            search: '',
            vademecumData: [],
            pagination: {},
            rowsPerPageItems: [5, 10, 15, 20],
            selectedItem: '',
            headers: [{
                    text: i18n.t('headers.plu'),
                    sortable: false,
                    value: "plu"
                },
                {
                    sortable: false,
                    text: i18n.t('headers.name'),
                    value: "name"
                },
                {
                    sortable: false,
                    text: i18n.t('headers.watched'),
                    value: "isWatched",
                    align: "left"
                },
                {
                    sortable: false,
                    text: i18n.t('headers.applicable'),
                    value: "isApplicable",
                    align: "left"
                },
                {
                    sortable: false,
                    text: i18n.t('headers.featured'),
                    value: "isFeatured",
                    align: "left"
                }
            ],
            itemVademecum: [{
                    text: i18n.t('headers.watched')
                },
                {
                    text: i18n.t('headers.applicable')
                },
                {
                    text: i18n.t('headers.featured')
                }
            ]
        };
    },
    computed: {
        customHeaders() {
            return this.enabledColumns ? this.headers.filter(header => this.enabledColumns[header.id]) : this.headers
        }
    },
    
    props:[
        {
            getDataVademecum: {
                type: Array,
                default: () => []
            }
        },
        "enabledColumns"
    ],
    watch: {
        pagination: {
            handler() {
                if (this.search != "" || this.selectedItem != "") {
                    this.busquedaItem()
                }else {
                    this.getVademecum();
                }
                
            },
            deep: true
        }
    },
    methods: {
        onRowClick(item) {
            this.vademecumDataEdit = [item]
            this.showEditVadmecum = true
        },
        getVademecum() {
            console.log("Entro a consultar totros")
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            vademecumService.getVademecum(page - 1, rowsPerPage).then(response => {
                this.vademecumData = response.data[0];
                this.total = response.data[1];
                this.loading = false;
                return this.vademecumData;
            });
        },
        sendVademecum() {
            vademecumService.updateVademecumItem(this.vademecumDataEdit[0]).then(response => {
                this.$notify({
                    group: "app",
                    type: "success",
                    text: i18n.t('vademecum-updated')
                });
                this.showEditVadmecum = false;
                this.getVademecum();
            });
        },
        busquedaItem() {
            this.loading = true;
            if (this.search === '' && this.selectedItem === '') {
                this.getVademecum();
            }else if (this.search === '' && this.selectedItem === undefined) {
                this.getVademecum();
            }else {
                if (this.selectedItem != '' && this.selectedItem != undefined) {
                    let item = '';
                    let bool = false;
                    if (this.selectedItem.toString() == i18n.t('headers.watched')) {
                        item = 'isWatched';
                        bool = true;
                    }
                    if (this.selectedItem.toString() == i18n.t('headers.applicable')) {
                        item = 'isApplicable';
                        bool = true;
                    }
                    if (this.selectedItem.toString() == i18n.t('headers.featured')) {
                        item = 'isFeatured';
                        bool = true;
                    }
    
                    const { page, rowsPerPage } = this.pagination;
                    vademecumService.findDescripcion(item, bool, page - 1, rowsPerPage).then(response => {
                        this.vademecumData = response.data[0];
                        this.total = response.data[1];
                        this.loading = false;
                        return this.vademecumData;
                    }).catch(error => {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: error
                        });
                    })
                    // this.selectedItem = '';
                }
    
                if (this.search.toString() != '') {
                    const { page, rowsPerPage } = this.pagination;
                    vademecumService.findIdPlu(this.search, page - 1, rowsPerPage).then(result => {
                        this.vademecumData = result.data[0];
                        this.total = result.data[1];
                        this.loading = false;
                        return this.vademecumData;
                    }).catch(error => {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: error
                        });
                    })
                    // this.search = '';
                }
            }

        }
    }
};